import React from 'react'

class GreyBig extends React.Component {
  render() {
    const {
      size,
      grey,
      big,
      capitalizeFirstLetter
    } = this.props

    return (
      <div className={`${classes.margin[size]}`}>
        <div className='grey'>
          {grey}
        </div>
        <div className={ `big ${capitalizeFirstLetter ? 'capitalize-first-letter' : '' }` }>
          {big}
        </div>
      </div>
    )
  }
}

const classes = {
  margin: {
    4: 'mb-4',
    3: 'mb-3',
    2: 'mb-2',
    block: 'd-block',
  },
}

export default GreyBig;
